module.exports = __webpack_public_path__ + "img/Ele6.326a8e61.jpg";